import React, { useState } from 'react';

const TerminationModal = ({ 
  isOpen, 
  onClose, 
  address,
  contract, 
  onSubmit
}) => {
    const terminationOptions = [
        "Water Rights",
        "Inspection",
        "Lease Review",
        "Insurability", 
        "Due Diligence Documents",
        "Zoning",
        "New Loan Terms",
        "Environmental",
        "New Loan Availability",
        "Conditional Sale",
        "Existing Loan Review",
        "Lead Based Paint",
        "Appraised Value",
        "Meth Lab",
        "Association Documents",
        "Estoppel Statements",
        "Certificate of Title",
        "Causes of Loss",
        "Record Title, Off-Record Title",
        "Damage, Inclusions",
        "Mineral Rights Exam",
        "Condemnation",
        "Survey",
        "Short Sale Addendum",
        "Other"
      ];

    const [terminationType, setTerminationType] = useState([]); 
    const [otherText, setOtherText] = useState('');

    const handleCheckboxChange = (option) => {
        setTerminationType(prev =>
          prev.includes(option)
            ? prev.filter(item => item !== option)
            : [...prev, option]
        );
      };
    
      const handleSubmit = () => {
        // Build an object with your termination data
        const terminationData = { 
          terminationType,
          other: terminationType.includes("Other") ? otherText : null 
        };
        onSubmit(terminationData, contract);
      };

  if (!isOpen) return null;

return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-semibold mb-4">Contract Termination</h2>
        <p className="text-sm text-gray-700 mb-4">
          You are about to submit a Termination form on <span className="font-bold">{address}</span>.
          Select the type(s) of termination you want to proceed with.
        </p>
        <div className='relative mb-4'>
        <div className="max-h-[35vh] overflow-y-scroll">
          {terminationOptions.map(option => (
            <div key={option} className="flex items-center p-1">
              <input
                type="checkbox"
                id={option}
                checked={terminationType.includes(option)}
                onChange={() => handleCheckboxChange(option)}
              />
              <label htmlFor={option} className="ml-2 text-sm text-gray-700">{option}</label>
            </div>
          ))}
          <div className="pointer-events-none absolute bottom-0 left-0 w-full h-6 bg-gradient-to-t from-white"></div>
        </div>
        </div>
        {terminationType.includes("Other") && (
          <div className="mb-4">
            <label className="block text-sm text-gray-700 mb-1">Other Termination Type:</label>
            <input 
              type="text" 
              value={otherText} 
              onChange={(e) => setOtherText(e.target.value)} 
              className="border rounded p-2 w-full"
              placeholder="Enter other termination details"
            />
          </div>
        )}
        <p className="text-xs text-gray-600 mb-4">
          NOTE: Once the terminating parties sign, you will need to forward this terminating contract to the seller to make it official. Once you do so, the contract will be terminated.
        </p>
        <div className="flex justify-end gap-4">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button 
            onClick={handleSubmit}
            className="px-4 py-2 bg-shi-green text-white rounded hover:bg-green-700"
          >
            Sign and Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default TerminationModal;